import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { toast } from "react-toastify";
import DynamicDataTable from "../../common/components/Common/DataListing"
import { getClassRooms, addClassRoom, editClassRoom, deleteClassRoom } from "../../api/classRoomApi";
const ClassRoomList = () => {
  const [classRooms, setClassRooms] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classRoomData, setClassRoomData] = useState({
    name: "",
    type: null,
    location: "",
    capacity: null,
    is_active: true,
    notes: "",
  });
  const dt = useRef(null);

  useEffect(() => {
    fetchClassRooms();
  }, []);

  const fetchClassRooms = async () => {
    setLoading(true);
    try {
      const data = await getClassRooms();
      setClassRooms(Array.isArray(data) ? data : []);
    } catch (error) {
      toast.error("Failed to fetch classrooms.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setClassRoomData({
      name: "",
      type: null,
      location: "",
      capacity: null,
      is_active: true,
      notes: "",
    });
  };

  const handleCreate = () => {
    setIsEditing(false);
    resetForm();
    setIsModalVisible(true);
  };

  const handleEdit = (rowData) => {
    setIsEditing(true);
    setClassRoomData({ ...rowData });
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteClassRoom(id);
      toast.success(response.message);
      fetchClassRooms();
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed.");
    }
  };
  const getAllClassRooms = async () => {
      setLoading(true);
      try {
        const res = await getClassRooms({});
        
        setClassRoomData(res.data || []);
      } catch {
        toast.error('Failed to load curriculum');
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {  getClassRooms(); getAllClassRooms(); }, []);

  const removeRow = async (row) => {
      try {
        const id = typeof row === 'object' ? row.id : row;
        const res = await deleteClassRoom(id);
        if (res.success === false) return toast.error(res.message || 'Remove failed');
        toast.success('Removed');
        getAllClassRooms();
        fetchClassRooms()
      } catch {
        toast.error('Remove failed');
      }
    };


  const handleSubmit = async () => {
    if (!classRoomData.name) {
      toast.error("ClassRoom name is required.");
      return;
    }

    setLoading(true);
    try {
      const response = isEditing
        ? await editClassRoom(classRoomData.id, classRoomData)
        : await addClassRoom(classRoomData);
      
      toast.success(response.message);
      fetchClassRooms();
      setIsModalVisible(false);
      resetForm();
    } catch (error) {
      toast.error(error.response?.data?.message || "Save failed.");
    }
  };

  const columns = [
    { field: "name", header: "Name" },
    { field: "type", header: "Type" },
    { field: "location", header: "Location" },
    { field: "capacity", header: "Capacity" },
    {
      field: "is_active",
      header: "Active",
      body: (rowData) => (rowData.is_active ? "Yes" : "No"),
    },
  ];

  const classRoomTypes = [
    { label: "Classroom", value: "classroom" },
    { label: "Lab", value: "lab" },
    { label: "Hall", value: "hall" },
  ];

  return (
    <div>
      <DynamicDataTable
        ref={dt}
        data={classRooms}
        columns={columns}
        subject="ClassRoom"
        loading={loading}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={(id) => removeRow(id)}
      />

      <Dialog
        header={isEditing ? "Edit ClassRoom" : "Create ClassRoom"}
        visible={isModalVisible}
        style={{ width: "650px" }}
        modal
        onHide={() => setIsModalVisible(false)}
      >
        <div className="flex justify-content-center gap-2">
          <div className="w-6">
          <label htmlFor="name">Name</label>
          <InputText className="w-full border-1 border-gray-400" id="name" value={classRoomData.name} onChange={(e) => setClassRoomData({ ...classRoomData, name: e.target.value })} required autoFocus />
          </div>
        <div className="w-6">
          <label htmlFor="type">Type</label>
          <Dropdown id="type" className="w-full border-1 border-gray-400" value={classRoomData.type} options={classRoomTypes} onChange={(e) => setClassRoomData({ ...classRoomData, type: e.value })} placeholder="Select a Type" />
        </div>
        </div>
        <div className="flex gap-2 mt-2">
        <div className="w-6">
          <label htmlFor="location">Location</label>
          <InputText id="location" className="w-full border-1 border-gray-400" value={classRoomData.location} onChange={(e) => setClassRoomData({ ...classRoomData, location: e.target.value })} />
        </div>
        <div className="w-6">
          <label htmlFor="capacity">Capacity</label>
          <InputNumber id="capacity" className="w-full border-1 border-gray-400" value={classRoomData.capacity} onValueChange={(e) => setClassRoomData({ ...classRoomData, capacity: e.value })} mode="decimal" />
        </div>
        </div>
        <div className="p-field">
          <label htmlFor="notes">Notes</label>
          <InputTextarea className="border-1 border-gray-400" id="notes" value={classRoomData.notes} onChange={(e) => setClassRoomData({ ...classRoomData, notes: e.target.value })} rows={3} />
        </div>
        <div className="p-field flex align-items-center">
          <InputSwitch checked={classRoomData.is_active} onChange={(e) => setClassRoomData({ ...classRoomData, is_active: e.value })} />
          <label htmlFor="is_active" className="ml-2 my-4">Active</label>
        </div>
        <div className=" flex justify-content-end">
          <Button className="w-full" label={isEditing ? "Update" : "Create"}  onClick={handleSubmit} />
        </div>
      </Dialog>
    </div>
  );
};

export default ClassRoomList;

